module.exports = __webpack_public_path__ + "img/gaodian.01282459.png";